module.exports = __webpack_public_path__ + "static/media/adultWhite.e22a59a3.svg";